
import { CommoditySysRuter } from "@/modules/commodity-sys/router";
import { FundRuter } from "@/modules/fund/router";
import { LogisticsRoute } from "@/modules/logistics/router";
import { OrderRuter } from "@/modules/order/router";
import { OrderPdRouter } from "@/modules/order-pd/router";
//门店订货单  发货单（总部——门店）
import { OrderMdRouter } from "@/modules/order-md/router";
import { OrderStoreRuter } from "@/modules/orderstore/router";
import { OrderOverseasRuter } from "@/modules/orderoverseas/router";
import { PrepareRuter } from "@/modules/prepare/router";
import { SubjectRouter } from "@/modules/subject/router";
import Module_Stores from "@/modules/stores/routes";
import Module_Roles from "@/modules/roles/routes";
//热更新路由
import Module_Hot from "@/modules/hotRenewal/routes";
import Module_Accounts from "@/modules/accounts/routes";
import Module_Clients from "@/modules/clients/routes";
import Module_Role_Warehouse from "@/modules/role_warehouse/routes";
import { WmsManageRuter } from "@/modules/wms-manage/router";
//系统管理路由
import Task_List from "@/modules/task/routes";
//分销运营
import distribution from './distribution';
//分销运营-任务管理
import taskManage from './taskManage';
//发票管理
import invoiceRouter from "@/modules/invoice-manage/routes"
let routes_config = [

  {
    // =============================================================================
    // MAIN LAYOUT ROUTES
    // =============================================================================

    path: '',
    component: () => import('../layouts/main/Main.vue'),
    children: [
      // =============================================================================
      // Group Cloud
      // =============================================================================

      {
        path: '/home/index',
        name: 'home-index',
        component: () => import('../views/group-cloud/home/index.vue'),
        meta: {
          pageTitle: 'Yooz',
        }
      },

      LogisticsRoute,
      CommoditySysRuter,
      FundRuter,
      Module_Stores,
      Module_Clients,
      Module_Hot,
      Module_Roles,
      Module_Accounts,
      OrderRuter,
      OrderPdRouter,
      OrderMdRouter,
      OrderStoreRuter,
      OrderOverseasRuter,
      PrepareRuter,
      SubjectRouter,
      Module_Role_Warehouse,
      WmsManageRuter,
      Task_List,
      // 分销运营
      invoiceRouter,
      distribution,
      taskManage,
      {
        path: '/user-settings',
        name: 'gc-user-settings',
        component: () => import('@/views/group-cloud/user-settings/UserSettings.vue'),
        meta: {
          pageTitle: '账户设置',
        }
      },
      {
        path: '/',
        redirect: '/home/index'
      },
    ]
  },

  // =============================================================================
  // FULL PAGE LAYOUTS
  // =============================================================================
  {
    path: '',
    component: () => import('@/layouts/full-page/FullPage.vue'),
    children: [
      // =============================================================================
      // PAGES
      // =============================================================================
      {
        path: '/pages/register',
        name: 'page-register',
        component: () => import('@/views/pages/register/Register.vue'),
        meta: {
          role: 'public'
        }
      },
      {
        path: '/pages/login',
        name: 'page-login',
        component: () => import('@/views/pages/login/Login.vue'),
        meta: {
          role: 'public'
        }
      },
      {
        path: '/pages/logout',
        name: 'page-logout',
        component: () => import('@/views/pages/login/Logout.vue'),
        meta: {
          role: 'public'
        }
      },
      {
        path: '/pages/recoverPassword',
        name: 'page-recover-password',
        component: () => import('@/views/pages/login/RecoverPassword.vue'),
        meta: {
          role: 'public'
        }
      },
      {
        path: '/pages/error-404',
        name: 'page-error-404',
        component: () => import('@/views/pages/Error404.vue'),
        meta: {
          role: 'public'
        }
      },
      {
        path: '/pages/error-500',
        name: 'page-error-500',
        component: () => import('@/views/pages/Error500.vue'),
        meta: {
          role: 'public'
        }
      },
      {
        path: '/pages/not-authorized',
        name: 'page-not-authorized',
        component: () => import('@/views/pages/NotAuthorized.vue'),
        meta: {
          role: 'public'
        }
      }

    ] // full-page-children
  },
  // Redirect to 404 page, if no match found
  {
    path: '*',
    redirect: '/pages/error-404'
  }
];


export const RoutesConfig = routes_config;
